import { useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";

const DropdownTriangle = ({ options = [], onClick = () => {} }) => {
  const { t } = useTranslation();

  const [openDropdown, setOpenDropdown] = useState(false);

  const handleOpenDropdown = () => {
    setOpenDropdown((it) => !it);
  };

  const handleClickOption = (val) => {
    onClick(val);
    setOpenDropdown(false);
  };

  return (
    <div
      className="dropdown-triangle-container"
      tabindex="0"
      onBlur={() => {
        if (openDropdown) {
          handleOpenDropdown();
        }
      }}
    >
      <div className="three-dot-button" onClick={handleOpenDropdown}>
        ⚫⚫⚫
      </div>
      <div
        className="article-filter-dropdown"
        style={{ display: openDropdown ? "block" : "none" }}
      >
        <div className="triangle-up"></div>
        <div className="article-options">
          {options?.map((item) => (
            <div
              className="article-options-item"
              onClick={() => handleClickOption(item)}
            >
              {t(item?.title)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DropdownTriangle;
